<template>
    <div>
        <!-- 导航栏 -->
        <van-nav-bar title="咨询记录" left-arrow @click-left="onClickLeft" />
        <van-form validate-first @failed="onFailed" @submit="submit">
            <van-field label="姓名" :value="this.$store.state.user.name" readonly />
            <van-field label="联系方式" :value="this.$store.state.user.phone" readonly />
            <van-field
                    v-model="title"
                    name="validator"
                    label="咨询标题"
                    placeholder="请输入咨询标题"
                    maxlength="30"
                    show-word-limit
                    autosize
                    :rules="[{ validator, message: `请输入标题`}]"
            />
            <van-field
                    v-model="content"
                    name="validator"
                    label="咨询内容"
                    placeholder="请输入咨询内容"
                    type="textarea"
                    maxlength="300"
                    show-word-limit
                    autosize
                    :rules="[{ validator, message: `请输入内容`}]"
            />

            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit" >
                    提交
                </van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
  import axios from '../../common/axios'
  import {responseCodes} from '../../common/const'
  import {Toast} from 'vant'


  export default {
    data() {
      return {
        title: '',
        content: '',
      };
    },
    methods: {
      validator(val) {
        return val.trim().length>0
      },
      onFailed(errorInfo) {
        console.log('failed', errorInfo);
      },

      onClickLeft() {
        this.$router.back();
      },
      async submit(){
        this.$store.commit("showOverlay");
        let consult = {
          title: this.title,
          content:this.content,
          openId:this.$store.state.user.openId
        };
        try {
          let response = await axios.post("/fyserve/consult/addConsult/v2" ,consult)
          let data = response.data;
          if (data.code === responseCodes.success) {
             this.$emit('addconsult')
          }else{
            Toast.fail(data.message);
          }
        }catch (e) {
          console.error(e)
          Toast.fail("加载数据失败")
        }finally {
          this.$store.commit("hideOverlay")
          this.title = '';
          this.content = ''
        }
      }
    },
  };
</script>

<style>

</style>
